import { render, staticRenderFns } from "./AppTranslator.vue?vue&type=template&id=a20ddf78&scoped=true&"
import script from "./AppTranslator.vue?vue&type=script&lang=js&"
export * from "./AppTranslator.vue?vue&type=script&lang=js&"
import style0 from "./AppTranslator.vue?vue&type=style&index=0&id=a20ddf78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20ddf78",
  null
  
)

export default component.exports